import '../../startup/public-path';
import './styles/main.less';
import app from '../../startup/app';
import hydrateApp from '../../startup/hydrate-app';
import {Template} from '../../../shared/templates/multi-destination';

app(() => hydrateApp(Template));
